import {
  createSlice,
  createAsyncThunk,
  Dictionary,
  PayloadAction,
} from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export const fetchInitialLayout = createAsyncThunk(
  "layout/fetchInitialLayout",
  async () => {
    const response = await fetch(
      "https://app.singular.live/apiv1/control/07R3fzGV3Xk2ggDyXOVyjr"
    );
    var body = await response.json();
    return body as Array<Dictionary<any>>;
  }
);

interface layoutState {
  currentlayout: string;
  streamSlots: Array<string | null>;
  waitingScreen: boolean;
  setVolume: number;
  desiredVolume: number;
}

const initialState: layoutState = {
  currentlayout: "Fullscreen",
  streamSlots: [null, null, null, null],
  waitingScreen: false,
  setVolume: -1,
  desiredVolume: 100,
};

export const layoutSlice = createSlice({
  name: "layout",
  initialState: initialState,
  reducers: {
    changeLayout: (state, action: PayloadAction<string>) => {
      state.currentlayout = action.payload;
    },
    changeStream: (state, action) => {
      var newStreamSlots = [...state.streamSlots];
      newStreamSlots[action.payload.slot] = action.payload.stream;
      state.streamSlots = newStreamSlots;
    },
    changeWaitingScreen: (state, action) => {
      state.waitingScreen = action.payload;
    },
    changeSetVolume: (state, action) => {
      state.setVolume = action.payload;
    },
    changeDesiredVolume: (state, action) => {
      state.desiredVolume = action.payload;
    }
  },
});

export const { changeLayout, changeStream, changeWaitingScreen, changeSetVolume, changeDesiredVolume } =
  layoutSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectLayout = (state: RootState) => state.layout.currentlayout;
export const selectStreamSlots = (state: RootState) => state.layout.streamSlots;
export const selectWaitingScreen = (state: RootState) => state.layout.waitingScreen;
export const selectSetVolume = (state: RootState) => state.layout.setVolume;
export const selectDesiredVolume = (state: RootState) => state.layout.desiredVolume;

export default layoutSlice.reducer;
